// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerMenuSubmenuRootElement, type MenuSubmenuRootElement, type MenuSubmenuRootProps as MenuSubmenuRootElementProps, type MenuSubmenuRootEvents } from '@prosekit/web/menu';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

/** Props for the {@link MenuSubmenuRoot} React component. */
export interface MenuSubmenuRootProps {
  /**
   * Whether the overlay is initially open.
   * @default false
   */
  defaultOpen?: MenuSubmenuRootElementProps['defaultOpen'];
  /**
   * Whether the overlay is currently open.
   * @default null
   */
  open?: MenuSubmenuRootElementProps['open'];
  /**
   * Whether the component should ignore user interaction.
   * @default false
   */
  disabled?: MenuSubmenuRootElementProps['disabled'];
  /** Emitted when the submenu is opened or closed. */
  onOpenChange?: (event: MenuSubmenuRootEvents['openChange']) => void;
}

function MenuSubmenuRootComponent(props: MenuSubmenuRootProps, forwardedRef: ForwardedRef<MenuSubmenuRootElement>) {
  registerMenuSubmenuRootElement();

  const elementRef = useRef<MenuSubmenuRootElement>(null);
  const handlersRef = useRef<Array<((event: Event) => void) | undefined>>([]);

  const { defaultOpen: p0, disabled: p1, open: p2, onOpenChange: e0, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    Object.assign(element, { defaultOpen: p0, disabled: p1, open: p2 });
    handlersRef.current = [e0] as Array<((event: Event) => void) | undefined>;
  });

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    const ac = new AbortController();
    for (const [index, eventName] of ['openChange'].entries()) {
      element.addEventListener(
        eventName,
        (event: Event) => {
          handlersRef.current[index]?.(event);
        },
        { signal: ac.signal },
      );
    }
    return () => ac.abort();
  }, []);

  const mergedRef = useCallback(
    (element: MenuSubmenuRootElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-menu-submenu-root', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-menu-submenu-root` custom element. */
export const MenuSubmenuRoot: ForwardRefExoticComponent<MenuSubmenuRootProps & HTMLAttributes<MenuSubmenuRootElement> & RefAttributes<MenuSubmenuRootElement>> = /* @__PURE__ */ forwardRef(MenuSubmenuRootComponent);
